var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideo20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M3.255 6.172c0-.806.653-1.459 1.459-1.459h6.197c.806 0 1.459.653 1.459 1.459v7.656c0 .805-.653 1.458-1.459 1.458H4.714a1.46 1.46 0 0 1-1.459-1.458z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "m12.37 8.542 3.32-1.66a.73.73 0 0 1 1.055.652v4.932a.73.73 0 0 1-1.056.652l-3.32-1.66z"
})));
export default SvgVideo20;